import React from 'react';
import { Grid, IconButton, Tooltip, makeStyles } from '@material-ui/core';
import ListIcon from '@material-ui/icons/List';
import PlayCircleOutlineIcon from '@material-ui/icons/PlayCircleOutline';
import CloudDownloadIcon from '@material-ui/icons/CloudDownload';
import '../listItem.component.scss';
import { Link , useHistory} from 'react-router-dom';
// import moment from 'moment';
// import { globalDateEntity } from '../../../constants/applicationConstants';

const useStyles = makeStyles((theme) => ({
  icon: {
    color: theme.palette.primary.main,
  },
  rounded: {
    backgroundColor: theme.palette.grey[50],
    border: `1px solid #9D9D9D`,
    color: '#9D9D9D',
    width: '30px',
    height: '30px',
    cursor: 'pointer',
  },
  listItem: {
    color: '#434343',
    border: '1px solid #ededed',
    alignItems: 'center',
  },
}));

const StandardReport = ({ entityData , handleInlineStatusChange}) => {
  const classes = useStyles();
  const history = useHistory();
  /* let date;
  if (entityData.execution_datetime) {
    date = entityData.execution_datetime.replace(/-/g, '/');
    date = moment
      .utc(date)
      .local()
      .format(globalDateEntity.dateTimeFormatWith24Hour);
  } */
  return (
    <Grid container className={classes.listItem}>
      <Grid item xs={11}>
        <Grid container spacing={1} style={{ padding: '20px' }} alignItems='center'>
          <Grid item xs={12} className="textItemTitle">
            {entityData.title}
            <br />
          </Grid>

          <Grid item xs={6} className="secondaryText">
            Last Run Date: {entityData.execution_datetime}
          </Grid>
          {/* <Grid item xs={4}>
            Last Run User: {entityData.execution_datetime}
          </Grid> */}
          <Grid item xs={6} className="secondaryText" style={{textAlign: 'right'}}>
            <Grid>
              {entityData.query.includes('_CONFIGURABLE') ? (
                <>
                  <Tooltip title="Apply Filter & Execute Report">
                    <IconButton
                      color="primary"
                      aria-label="Apply Filter & Execute Report"
                      onClick={(event) => {
                        // history.push(
                        //   `/standardreport/${encodeURIComponent(
                        //     entityData.PK,
                        //   )}`,
                        // );
                        handleInlineStatusChange(event, entityData)
                      }}
                    >
                      <ListIcon />
                    </IconButton>
                  </Tooltip>
                </>
              ) : (
                <Tooltip title="Execute Report">
                  <IconButton
                    color="primary"
                    aria-label="Execute Report"
                    onClick={() => {
                      history.push(
                        `/reportresult/standard/${encodeURIComponent(
                          entityData.PK,
                        )}`,
                      );
                    }}
                  >
                    <PlayCircleOutlineIcon />
                  </IconButton>
                </Tooltip>
              )}
              {entityData.last_generated_report != null ? (
                <Link
                  href="#"
                  onClick={(event) =>
                    handleInlineStatusChange(event, entityData, 'downloadReport')
                  }
                >
                  <Tooltip title={'Download'}>
                    <IconButton color="primary" aria-label={'Download'}>
                      <CloudDownloadIcon />
                    </IconButton>
                  </Tooltip>
                </Link>
              ) : (
                <IconButton
                  color="primary"
                  aria-label="Download Report"
                  disabled="true"
                >
                  <CloudDownloadIcon />
                </IconButton>
              )}
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default StandardReport;
